$(function () {

    /* search.js */

    var formObj = {};
    var accNum;
    var postCode;
    var $jsFlashWrap = $('.flash--wrap-confirm');
    var $jsFlashConfirm = $('#js-flash--button-confirm');
    var $formErrorEl = $('#js-search-form-error');
    var $elAjaxLoading = $('#js-ajax-loading');

    // determine how many searches are available
    gotSearchesLeft();

    // get the single form
    formObj.el = $('#js-singlesearch-form');

    // handle the submitting of a single search form
    formObj.el.submit(function (event) {

        event.preventDefault();

        formObj.el.find('.btn-primary').attr('disabled', true);

        submitSearchForm($('#js-singlesearch-form'));

    });

    ////////////////////////////////////////
    // saved search in page table generation
    ////////////////////////////////////////

    $('.js-saved-search').on('click', generateSavedSearchDom);


    /**
     * Handle the submitted form
     *
     * @param form
     */
    function submitSearchForm(form) {

        // get form inputs
        form.find('input').each(function (index, el) {

            if (el.name == "account_no") {
                accNum = $(el).val().length > 0;
            }

            if (el.name == "postcode") {
                postCode = $(el).val().length > 0;
            }

        });

        // show error if either an account number or postcode is missing
        if (accNum == false && postCode == false) {

            $formErrorEl.text('You must enter either an account number or postcode');
            $formErrorEl.fadeIn();

            setTimeout(function () {
                $formErrorEl.text('');
                $formErrorEl.fadeOut();
            }, 3000);

            formObj.el.find('.btn-primary').attr('disabled', false);

        } else {

            $formErrorEl.text('');
            $formErrorEl.fadeOut();
            $('#js-no-results-message').text('');

            $.ajax({
                url: '/single-search/request',
                method: 'post',
                data: form.serializeArray(),
                dataType: "json",
                beforeSend: function () {

                    // remove previous data
                    removeTable('#js-single-results-table_wrapper');

                    $elAjaxLoading.fadeIn();
                },
                success: function () {
                    $elAjaxLoading.fadeOut();
                },
                error: function (jqXHR, statusText) {
                    $elAjaxLoading.fadeOut();

                    if ( jqXHR.statusText == 'Unauthorized' ){

                        // redirect user to log in page
                        window.location.reload();

                    } else {
                        // this should not show unless something is wrong server side
                        doFlashConfirm($jsFlashWrap, 'error', 'SORRY', 'Could not complete request');
                    }
                }
            }).done(function (json) {

                // data comes back either with records or without
                if (json.length > 0) {

                    // if data append to page - else show message
                    if (json[0].hasOwnProperty('message')) {
                        appendMessageToHtmlInsteadOfTable('#js-no-results-message', json[0].message);
                    } else {
                        makeTable(json, 'single');
                    }

                } else {
                    // this should not show unless something is wrong server side
                    doFlashConfirm($jsFlashWrap, 'error', 'SORRY', 'No data was returned!?');
                }

                formObj.el.find('.btn-primary').attr('disabled', false);
            });
        }
    }

    /////////////////////////////////////
    //Handle the form for batch searches
    ////////////////////////////////////

    // check for data in the dom
    if ($('input[name=csv]').length != 0 && $('input[name=csv]').val() != "") {

        var json = $.parseJSON($('input[name=csv]').val());
        var $dlButton;
        var $icon;

        if (json) {

            // data comes back either with records or without
            if (json.hasOwnProperty('matches') || json.hasOwnProperty('noMatches') || json.hasOwnProperty('addLibMatches') || json.hasOwnProperty('postCodeOnlyMatches') || json.hasOwnProperty('message')) {

                // show the message or append matched data
                if (json.hasOwnProperty('message')) {

                    appendMessageToHtmlInsteadOfTable('#js-no-results-message', json.message);
                } else {

                    $("#batch-tabs").fadeIn();

                    // make tabs for batch result
                    $("#batch-tabs").tabs();

                    // show the non matched data
                    if (json.hasOwnProperty('matches')) {

                        if (json.matches.length > 0) {
                            // console.log('batch');

                            $dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/matches/csv', target: '_blank'});
                            $icon = $('<i></i>',{ 'class': 'fa fa-download' });
                            $icon.appendTo($dlButton);

                            $('#js-matches').append($dlButton);

                        // <a class="batch-download-csv" href="/addLibMatches/{{ Session::get('councilInSession') }}/csv" target="_blank"><i class="fa fa-download"></i></a>

                            makeTable(json.matches, 'batch-matches');
                        }
                    }

                    // show the non matched data
                    if (json.hasOwnProperty('noMatches')) {

                        if (json.noMatches.length > 0) {
                            // console.log('noMatch');

                            $dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/noMatches/csv', target: '_blank'});
                            $icon = $('<i></i>',{ 'class': 'fa fa-download' });
                            $icon.appendTo($dlButton);

                            $('#js-noMatches').append($dlButton);

                            makeTable(json.noMatches, 'batch-no-matches');
                        }
                    }
					
					console.log(json);

                    // show the non matched data
                    if (json.hasOwnProperty('postCodeOnlyMatches')) {
						
						console.log(json.postCodeOnlyMatches);

                        if (json.postCodeOnlyMatches.length > 0) {
                            // console.log('pCode match');

                            $dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/postCodeOnlyMatches/csv', target: '_blank'});
                            $icon = $('<i></i>',{ 'class': 'fa fa-download' });
                            $icon.appendTo($dlButton);

                            $('#js-postCodeOnlyMatches').append($dlButton);

                            makeTable(json.postCodeOnlyMatches, 'batch-postcode-only');
                        }
                    }

                    // show the non matched data
                    if (json.hasOwnProperty('addLibMatches')) {

                        if (json.addLibMatches.length > 0) {
                            // console.log('addlib match');

                            $dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/addLibMatches/csv', target: '_blank'});
                            $icon = $('<i></i>',{ 'class': 'fa fa-download' });
                            $icon.appendTo($dlButton);

                            $('#js-addLibMatches').append($dlButton);

                            makeTable(json.addLibMatches, 'batch-additional-liables');
                        }
                    }
                }

            } else {

                // this should not show unless something is wrong server side
                doFlashConfirm($jsFlashWrap, 'error', 'SORRY', 'No data was returned!?');
            }
        }
    }


    /**
     * The function to generate or regenerate saved search tables
     *
     */
    function generateSavedSearchDom() {

        var batchTabs = $("#batch-tabs");
		
		$.get('/batch-search/load/' + $(this).parent().data('saved-search-id'), function(data) {
			//console.log(data);
		});

        // remove any existing tables and it's remnants
        removeTable('#js-batch-matches-results-table');
		$('#js-matches').find('a.batch-download-csv').remove();
        removeTable('#js-batch-no-matches-results-table');
		$('#js-noMatches').find('a.batch-download-csv').remove();
        removeTable('#js-batch-postcode-only-results-table');
		$('#js-postCodeOnlyMatches').find('a.batch-download-csv').remove();
        removeTable('#js-batch-additional-liables-results-table');
		$('#js-addLibMatches').find('a.batch-download-csv').remove();

        batchTabs.fadeOut(100, function () {

            // make sure ui tab header values are reset to 0
            $('.ui-tabs-nav').find('li').each(function (index, el) {

                span = $(el).find('span');

                span.text(0);
            });

            $elAjaxLoading.fadeIn();
        });

        var json = $(this).parent().data('saved-search');
		var savedSearchTitle = $(this).parent().data('saved-search-title');
		// 1 - old searches with 4 group of results, 2 new searches where matches and add. liable were merged
		var savedSearchType = $(this).parent().data('saved-search-type');
		if (savedSearchType == 1) {
			// there is add. liable tab
			$('#js-addLibMatches').show();
		} else {
			// no add. liable tab
			$('#js-addLibMatches').hide();
		}
		var counts = {};

        var highest = 0;
        var showTab = '';

        setTimeout(function () {

            $elAjaxLoading.fadeOut(100, function () {
				
				$('#batch-tabs h2').html(savedSearchTitle);

                if (json.hasOwnProperty('matches')) {

                    if (json.matches.length > 0) {

                        if (json.matches.length > highest) {
                            highest = json.matches.length;
                            showTab = "#js-batch-matches-results-wrap";
                        }
						
						$dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/matches/csv', target: '_blank'});
						$icon = $('<i></i>',{ 'class': 'fa fa-download' });
						$icon.appendTo($dlButton);

						$('#js-matches').append($dlButton);

                        makeTable(json.matches, 'batch-matches');
                    }
                }

                if (json.hasOwnProperty('noMatches')) {

                    if (json.noMatches.length > 0) {

                        if (json.noMatches.length > highest) {
                            highest = json.noMatches.length;
                            showTab = "#js-batch-no-matches-results-wrap";
                        }
						
						$dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/noMatches/csv', target: '_blank'});
						$icon = $('<i></i>',{ 'class': 'fa fa-download' });
						$icon.appendTo($dlButton);

						$('#js-noMatches').append($dlButton);

                        makeTable(json.noMatches, 'batch-no-matches');
                    }
                }

                if (json.hasOwnProperty('postCodeOnlyMatches')) {

                    if (json.postCodeOnlyMatches.length > 0) {

                        if (json.postCodeOnlyMatches.length > highest) {
                            highest = json.postCodeOnlyMatches.length;
                            showTab = "#js-batch-postcode-only-results-wrap";
                        }
						
						$dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/postCodeOnlyMatches/csv', target: '_blank'});
						$icon = $('<i></i>',{ 'class': 'fa fa-download' });
						$icon.appendTo($dlButton);

						$('#js-postCodeOnlyMatches').append($dlButton);

                        makeTable(json.postCodeOnlyMatches, 'batch-postcode-only');
                    }
                }

				if (savedSearchType == 1) {
					if (json.hasOwnProperty('addLibMatches')) {

						if (json.addLibMatches.length > 0) {

							if (json.addLibMatches.length > highest) {
								highest = json.addLibMatches.length;
								showTab = "#js-batch-additional-liables-results-wrap";
							}

							$dlButton  = $('<a></a>', { 'class': 'batch-download-csv', href: '/addLibMatches/csv', target: '_blank'});
							$icon = $('<i></i>',{ 'class': 'fa fa-download' });
							$icon.appendTo($dlButton);

							$('#js-addLibMatches').append($dlButton);

							makeTable(json.addLibMatches, 'batch-additional-liables');
						}
					}
				}
                

                batchTabs.fadeIn();
                batchTabs.tabs();

                var index = $('#batch-tabs a[href="' + showTab + '"]').parent().index();

                // set the active tab
                batchTabs.tabs("option", "active", index);

            });
        }, 200);
    }


    /**
     * Take json object and make table to display records found from search criteria
     *
     * @param data
     * @param type
     */
    function makeTable(data, type) {

        var table = $('<table/>', {id: "js-" + type + "-results-table", class: "table table-striped"});
        var thead = $('<thead>').appendTo(table);
        var theadRow = $('<tr/>', {id: 'js-' + type + '-results-header'}).appendTo(thead);
        var tbody = $('<tbody>', {id: 'js-' + type + '-results-body'}).appendTo(table);
        var elResultsWrap = $('#js-' + type + '-results-wrap');
        var rowCount = 0;

        // Used for data detection
        var hasLiables = false, hasElec = false, dupeLineData = false;

        // The modal Dom references
        var elLiablesModal = $('#additionalLiablesModal'), elElectoralRollModal = $('#electoralRollModal'), elCsvRowModal = $('#csvRowModal');

        // used for the color matching line indexes
        var lineIndexes = [], dupeLineIndexes = [], lineIndexObjs = [], lineIndexColorCode;

        var dataLength = data.length;

        var step = 0;

        if (type == 'batch-matches') {
            $('#js-matches-found').text(data.length);
        }

        if (type == 'batch-no-matches') {
            $('#js-no-matches-found').text(data.length);
        }

        if (type == 'batch-postcode-only') {
            $('#js-postcode-only').text(data.length);
        }

        if (type == 'batch-additional-liables') {
            $('#js-batch-additional-liables').text(data.length);
        }


        $.each(data, function (key, data) {

            if (data.hasOwnProperty('line_index')) {

                if ($.inArray(data['line_index'], lineIndexes) == -1) {

                    lineIndexes.push(data['line_index']);

                    // rowIndex = {};
                    // rowIndex.id = data['line_index'];
                    // rowIndex.color = getRandomColor();
                    //
                    // lineIndexObjs.push(rowIndex);
                } else {
                    dupeLineIndexes.push(data['line_index']);

                    rowIndex = {};
                    rowIndex.id = data['line_index'];
                    // rowIndex.color = getRandomColor();
                    rowIndex.color = rainbow(dataLength, step);

                    step++;

                    lineIndexObjs.push(rowIndex);
                }
            }

        });

        $.each(data, function (key, data) {

            if (data.hasOwnProperty('singleUses')) {
                $('#js-search-uses-left').text(data['singleUses']);
                gotSearchesLeft();
                return;
            }

            var matches = [];

            // get matched data headings if data has any matches
            if (data.hasOwnProperty('criteria_matches')) {
                matches = data['criteria_matches'];
            }

            var trow = $('<tr>').appendTo(tbody);

            ///////////////////////////////////
            // Set up table, headers and values
            ///////////////////////////////////

            var hiddenTableColumns = ['id','liables','electoral_roll_arr','line_data','address_2','address_3','address_4'];

            for (prop in data) {
				//console.log(data);

                var td;
                var span;

                if (data.hasOwnProperty(prop) && hiddenTableColumns.indexOf(prop) == -1 ) {

                    var removedApostrophes;

                    if (typeof data[prop] == 'string'){
                        removedApostrophes = data[prop].replace('_','\'');
                    } else {
                        removedApostrophes = data[prop];
                    }

                    if (rowCount < 1) {

                        var th;

                        if (prop == 'add_libs') {

                            th = $('<th>', {id: ''}).text('Additional People').appendTo(theadRow);

                        } else if (prop == 'elec_roll') {

                            th = $('<th>', {id: ''}).text('Electoral Roll').appendTo(theadRow);

                        } else {

                            th = $('<th>', {id: ''}).text(prop.replace(/_/g, ' ')).appendTo(theadRow);
                        }
                    }

                    if (prop == 'line_index' && $.inArray(removedApostrophes, dupeLineIndexes) != -1) {

                        lineIndexColorCode = getCsvColor(removedApostrophes, lineIndexObjs);
                    }

                    // check if input data matches data sent back by control & highlight or set up data for modal(s)
                    if ($.inArray(prop, matches) != -1) {

                        td = $('<td/>', {class: "green"}).text(removedApostrophes);

                    } else if (prop == 'criteria_matches') {

                        td = $('<td/>').text(removedApostrophes.length);

                    } else if (prop == 'line_index' && data.hasOwnProperty('criteria_matches') && $.inArray(removedApostrophes, dupeLineIndexes) != -1) {

                        // add the csv object to the data attribute of the DOM node ( not DOM element )
                        td = $('<td/>').text(removedApostrophes + '  ').data('csv-row', [data['line_data']]);

                        // console.log(data['line_data']);

                        // flag to the events can be set up after all data has been looped
                        dupeLineData = true;

                        var a = $('<a>', {
                            class: 'js-confirm',
                            href: 'javascript:;'
                        }).attr('data-csv-row', true).text('    ').css({
                            backgroundColor: lineIndexColorCode,
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            width: '18px',
                            height: '14px'
                        });

                        a.appendTo(td);

                    }

                    else if (prop == 'add_libs') {

                        // console.log('batch search additional people');

                        // batch additional people
                        if (removedApostrophes != 0 && removedApostrophes != '0') {

                            hasLiables = true;

                            // add the csv object to the data attribute of the DOM node ( not DOM element )
                            td = $('<td/>').data('additional-liables', data["add_libs"]);

                            var a = $('<a\>', {
                                class: 'js-confirm',
                                href: 'javascript:;'
                            }).text(Object.keys(removedApostrophes).length).attr('data-additional-liables', true).appendTo(td);
                        } else {

                            td = $('<td/>').text(removedApostrophes);
                        }
                    } else if (prop == 'elec_roll') {

                        // console.log('batch search elec roll');

                        // batch electoral roll
                        if (removedApostrophes != 0 && removedApostrophes != '0') {

                            hasElec = true;

                            // add the csv object to the data attribute of the DOM node ( not DOM element )
                            td = $('<td/>').data('electoral-roll', data['elec_roll']);

                            var a = $('<a\>', {
                                class: 'js-confirm',
                                href: 'javascript:;'
                            }).text(Object.keys(removedApostrophes).length).attr('data-electoral-roll', true).appendTo(td);
                        } else {

                            td = $('<td/>').text(removedApostrophes);
                        }
                    } else {
                        td = $('<td/>').text(removedApostrophes);
                    }

                    td.appendTo(trow);
                }
            }

            rowCount++;

        });

        // append table to html
        elResultsWrap.append(table);

        if (type == 'single') {
            // console.log(type);
            elResultsWrap.fadeIn(1000);
        }

        //init dataTables
        $('#js-' + type + '-results-table').DataTable({
            order: [[3, "asc"]],
            paging: false,  // disable pagination
            bFilter: false, // disable search
            "sDom": '<"top">t<"bottom"ilp<"clear">>' // hides search and moves page selector to the bottom
        });

        $('#js-' + type + '-results-table').css({width: ''});

        //////////////////////////////////////////
        // Handle modal tables for additional data
        //////////////////////////////////////////

        if (hasLiables) {

            doClickEventAndSetTablesInModals('additional-liables', elLiablesModal);
        }

        if (hasElec) {

            doClickEventAndSetTablesInModals('electoral-roll', elElectoralRollModal);
        }

        if (dupeLineData) {

            doClickEventAndSetTablesInModals('csv-row', elCsvRowModal);
        }

    }


    /**
     * Creates the additional tables for pop up modals ( such as add libs / elec roll)
     *
     * @param data
     * @param tableName
     */
    function makeModalTable(data, tableName) {

        var table = $('<table/>', {
            id: "js-" + tableName + "-results-table",
            class: 'search-results'
        }).css({width: '100%'});

        var thead = $('<thead>').appendTo(table);
        var theadRow = $('<tr/>', {id: 'js-' + tableName + '-results-header'}).appendTo(thead);
        var tbody = $('<tbody>', {id: 'js-' + tableName + '-results-body'}).appendTo(table);
        var rowCount = 0;
        var elResultsWrap = $('#js-' + tableName + '-content');

        $.each(data, function (key, data) {

            var trow = $('<tr>').appendTo(tbody);

            if (data.hasOwnProperty('ctax_accounts_id')) {
                delete data['ctax_accounts_id'];
            }

            for (prop in data) {

                if (data.hasOwnProperty(prop)) {

                    var removedApostrophes;

                    if (typeof data[prop] == 'string'){
                        removedApostrophes = data[prop].replace('_','\'');
                    } else {
                        removedApostrophes = data[prop];
                    }

                    if (rowCount < 1) {

                        var th = $('<th>', {id: ''}).text(prop.replace(/_/g, ' ')).appendTo(theadRow);
                    }

                    if (removedApostrophes != 'null' && removedApostrophes != null) {

                        td = $('<td/>').text(removedApostrophes);
                    } else {

                        td = $('<td/>').text('');
                    }

                    td.appendTo(trow);
                }
            }

            rowCount++;
        });

        // append table to html
        elResultsWrap.append(table);
        // elResultsWrap.fadeIn(1000);  - messes with jquery tabs

    }


    /**
     * Flash Confirmation
     *
     * @param el
     * @param type
     * @param headerMsg
     * @param msg
     */
    function doFlashConfirm(el, type, headerMsg, msg) {

        el.fadeIn('1000');
        el.addClass(type);
        el.find('h3').text(headerMsg);
        el.find('p').text(msg);
        el.fadeIn('100', function () {
            $jsFlashConfirm.on('click', function () {
                el.fadeOut();
            });
        });
    }


    /**
     * Update search uses remaining
     *
     * @returns {boolean}
     */
    function gotSearchesLeft() {

        var elSearchesLeft = $('#js-search-uses-left');
        var searchesLeft = parseInt(elSearchesLeft.text());

        if (searchesLeft < 1) {

            elSearchesLeft.removeClass('uses-left--span-green').addClass('uses-left--span-red');
            return false;
        }

        return true;
    }


    /**
     * Add message to dom in place of the a table
     *
     * @param targetEl
     * @param message
     */
    function appendMessageToHtmlInsteadOfTable(targetEl, message) {

        $(targetEl).empty();

        if ($(targetEl).hasClass('blank')) {

            $(targetEl).removeClass('blank');
        }

        $(targetEl).css({display: 'block', textAlign: 'center', backgroundColor: 'AliceBlue'});

        $(targetEl).append(message);
    }


    /**
     * Wipe the table from html
     *
     * @param table
     */
    function removeTable(table) {

        $(table + '_wrapper').remove();

        $(table).fadeOut('500', function () {
            $(table).remove();
        });
    }

    /**
     * Get the colour for a given index
     *
     * @param csvIndex
     * @param arr
     * @returns {*}
     */
    function getCsvColor(csvIndex, arr) {

        var color;

        for (var i = 0; i < arr.length; i++) {

            if (parseInt(arr[i].id) == parseInt(csvIndex)) {
                color = arr[i].color;
            }
        }

        return color;
    }


    /**
     *
     * This function generates vibrant, "evenly spaced" colours (i.e. no clustering).
     * This is ideal for creating easily distinguishable vibrant markers in Google Maps and other apps.
     * Adam Cole, 2011-Sept-14
     * HSV to RBG adapted from: http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
     *
     * @param numOfSteps
     * @param step
     * @returns {string}
     */
    function rainbow(numOfSteps, step) {
        var r, g, b;
        var h = step / numOfSteps;
        var i = ~~(h * 6);
        var f = h * 6 - i;
        var q = 1 - f;
        switch (i % 6) {
            case 0:
                r = 1;
                g = f;
                b = 0;
                break;
            case 1:
                r = q;
                g = 1;
                b = 0;
                break;
            case 2:
                r = 0;
                g = 1;
                b = f;
                break;
            case 3:
                r = 0;
                g = q;
                b = 1;
                break;
            case 4:
                r = f;
                g = 0;
                b = 1;
                break;
            case 5:
                r = 1;
                g = 0;
                b = q;
                break;
        }
        var c = "#" + ("00" + (~~(r * 255)).toString(16)).slice(-2) + ("00" + (~~(g * 255)).toString(16)).slice(-2) + ("00" + (~~(b * 255)).toString(16)).slice(-2);
        return (c);
    }


    /**
     * Set up the events for when a user clicks a cell which has attached data e.g additional liables / electoral roll
     *
     * @param dataSetName
     * @param elDataSetModal
     */
    function doClickEventAndSetTablesInModals(dataSetName, elDataSetModal) {

        // set the click event
        $('a[data-' + dataSetName + '="true"]').click(function (event) {

            var data = $(this).parent().data(dataSetName);

            // loop through data and add it to the modal
            makeModalTable(data, dataSetName);

            elDataSetModal.modal('show');

            elDataSetModal.on('show.bs.modal', function () {

                // do something...

            });

            elDataSetModal.on('hidden.bs.modal', function () {

                // wipe the table from DOM
                removeTable('#js-' + dataSetName + '-results-table');
            });
        });
    }

});